enum LoggingSource {
  UIConfig = "SMES_UI_Cfg",
  UIDonor = "SMES_UI_Don",
  UIDonorPayment = "SMES_UI_DoP",
  UIFundingArea = "SMES_UI_FAr",
  UIFundingRequest = "SMES_UI_FRe",
  UINewSchoolRegistration = "SMES_UI_NSR",
  UIPrincipalRegistration = "SMES_UI_PRe",
  UISchoolOfficer = "SMES_UI_SOf",
  UISchool = "SMES_UI_Sch",
  UIUser = "SMES_UI_Usr",
  UIReferenceData = "SMES_UI_Ref",
  UIDonorDonationDetails = "SMES_UI_DDD",
  IPInfo = "SMES_VC_IPInfo",
  UISec = "SMES_UI_Sec",
  UISystemSetting = "SMES_UI_Sys",
  UIReporting = "SMES_UI_Rep",
  UIScheduledJob = "SMES_UI_SchJ",
  UIACARASchool = "SMES_UI_AcS",
}

export default LoggingSource;
